export const SPLIT_SCREEN_VALUE = {
  ONLY_LEFT: 'ONLY_LEFT',
  ONLY_RIGHT: 'ONLY_RIGHT',
  SPLIT: 'SPLIT',
};
